import React, { useEffect, Suspense, lazy, useState, useRef } from 'react';
//axios
import useAxiosHook from 'src/webapp/hooks/comn/axios.hook';
//fontAwesome
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
//datefomatter
import { format } from 'date-fns';
//observer
import { useInView } from 'react-intersection-observer';
//style
import styles from 'src/asset/scss/style/members.module.scss';
//Store
import useMembersStore from 'src/webapp/stores/members.store';
import usePartnerStore from 'src/webapp/stores/partner.store';
//Hook
import useComnHook from 'src/webapp/hooks/comn/comn.hook';
import useDatepickerHook from 'src/webapp/hooks/component/datepicker.hook';
import useMembersHook from 'src/webapp/hooks/members/members.hook';
//comp-wrapper
import Section from 'src/webapp/views/wrapper/Section';
import FixedPanel from 'src/webapp/views/wrapper/FixedPanel';
import FlickPanel from 'src/webapp/views/wrapper/FlickPanel';
//comp
import Element from 'src/webapp/views/wrapper/Element';//공통엘리먼트
import Menu from 'src/webapp/views/component/Menu';//메뉴
import TitleBar from 'src/webapp/views/component/title/TitleBar';
import SubTitleBar from 'src/webapp/views/component/title/SubTitleBar';//서브타이틀
import Spinner from '../component/loading/Spinner';
import Member from './Member';//회원정보
import EmptyData from 'src/webapp/views/component/EmptyData';//데이터없음

import DateRangeBottomsheet from 'src/webapp/views/component/datepicker/DateRangePicker';//공통 - date-range bottomsheet

export default function Members() {
    const { axiosPostHandler } = useAxiosHook();//axios
    const { isState, partner } = usePartnerStore();

    //Store
    //const { memberList } = useMembersStore();

    //Hook
    const { FontAwesomeIcon
        , compPreload//Preload
        , initDateHandler//날짜초기셋팅
    } = useComnHook();
    const { onDatepickerHandler } = useDatepickerHook();//날짜팝업
    const { initDataHandler//초기셋팅
        , reservMembersListAPI//예약회원리스트API
        , page//infinity페이지useState
        , searchWord//검색어입력useState
        , onSubmitSearch//검색창엔터
    } = useMembersHook();



    /* =============== 조회날짜-bottomsheet로 전달 =============== */
    const today = new Date();//오늘날짜
    const [ startDate,setStartDate ] = useState(new Date(today.setDate(today.getDate() - 7)));
    const [ endDate,setEndDate ] = useState(new Date());
    /* =============== 조회날짜-bottomsheet로 전달 =============== */
    /* =============== 날짜선택 팝업오픈여부 =============== */
    const [ datepicker,setDatePicker ] = useState(false);
    const onDatePickerDismissHandler = (value) => {
        setDatePicker(value);
    }
    /* =============== 날짜선택 팝업오픈여부 =============== */
    /* =============== 검색어입력 =============== */
    const [ searchword,setSearchword ] = useState('');
    /* =============== 검색어입력 =============== */
     /* =============== 검색어 엔터이벤트 =============== */
     const onEnterHandler = (e) => {
        if(e.key !== "Enter") { return; }
        setSearchword(e.target.value);
    }
    /* =============== 검색어 엔터이벤트 =============== */
    /* =============== 검색어 입력값없을떄 =============== */
    const onChangeHandler = (e) => {
        const value = e.target.value;
        if(value.length > 0) { return; }
        setSearchword(value);
    }
    /* =============== 검색어 입력값없을떄 =============== */
    /* =============== 매출리스트호출 =============== */
    const isLock = useRef(false);
    const pageRef = useRef(20);
    const [ memberList, setMemberList ] = useState([]);
    const memberListAPI = async(type) => {//type-0.첫로딩 or Socket, 1.스크롤
        if(isLock.current) { return; }
        
        isLock.current = true;
        const DATA = { PARTNER_CD:partner.COMN_CD, SEARCH_WORD:searchword, START_DATE:'20230603', END_DATE:'20250414', "ROWNUM":type === 0 ? 0 : pageRef.current };
        //const DATA = { PARTNER_CD:partner.COMN_CD, SEARCH_WORD:searchword, START_DATE:format(startDate, 'yyyyMMdd'), END_DATE:format(endDate, 'yyyyMMdd'), ROWNUM:type == 0 ? 20 : pageRef.current };
        const result = await axiosPostHandler(`memberReservListForPartner.do`, DATA);
        setTimeout(function() { isLock.current = false; }, 300);
        if(!result || result.message !== "SUCCESS") { pageRef.current = null; return; }
        if(result.message === "SUCCESS") {
            setMemberList(type === 0 ? result.data : memberList.concat(result.data));
            pageRef.current = result.data.length < 20 ? null : pageRef.current + 20;
        }
    };
    useEffect(() => {
        if(!isState) { return; }
        
        pageRef.current = 20;
        memberListAPI(0);
    }, [isState, startDate, endDate, searchword]);
    /* =============== 매출리스트호출 =============== */
    /* =============== 매출리스트 무한로딩호출 =============== */
    const [ inViewRef, inView] = useInView({ threshold: .5 });
    useEffect(() => {
        if(!inView && (memberList.length <= 0 || pageRef.current === null)) { return; }
        
        memberListAPI(1);
    }, [inView]);
    /* =============== 매출리스트 무한로딩호출 =============== */
    /* =============== 회원상세내역토글 =============== */
    const [ toggle,setToggle ] = useState(null);
    /* =============== 회원상세내역토글 =============== */

    return (
        <>
        <Section className={"section sectionContainer"}>
            <Menu />
            <Element tag={`div`} className={`container`}>
                <FixedPanel className={styles.fixedPanel}>
                    <TitleBar title={`회원관리`} />
                    <Element tag={`div`} className={styles.headContainer}>
                        <Element tag={`div`} className={styles.searchContainer}>
                            <Element tag={`time`}>{format(startDate, 'yyyy.MM.dd') + ' - ' + format(endDate, 'yyyy.MM.dd')}</Element>
                            <Element tag={`div`} className={styles.btnArea}>
                                <Element tag={`button`} anyprop={(e) => onDatePickerDismissHandler(true)}><FontAwesomeIcon icon="fa-light fa-calendar-lines" /></Element>
                                {/* <Element tag={`button`} anyprop={(e) => excelExportHandler()}><FontAwesomeIcon icon="fa-light fa-arrow-down-to-line" /></Element> */}
                            </Element>
                        </Element>
                    </Element>
                    <div className={styles.searchwordContainer}>
                        <dl><dd><h1>방문자수</h1></dd><dd><h2>총 {memberList.length}명</h2></dd></dl>
                        <div>
                            <FontAwesomeIcon icon="fa-light fa-magnifying-glass" />
                            <input type="text" onKeyDown={(e) => onEnterHandler(e)} onChange={(e) => onChangeHandler(e)} placeholder={`회원을 검색해보세요.`} />
                        </div>
                    </div>
                </FixedPanel>
                <FlickPanel>
                    {memberList.length > 0 ?
                        <Element tag={`div`} className={styles.membersContainer}>
                            <SubTitleBar title={`회원(${memberList.length})`} />
                            <Element tag={`ul`} className={styles.salesContainer}>
                                {memberList.map((item, idx) =>
                                    <Element tag={`li`} key={idx} anyprop={(e) => setToggle(item === toggle ? null : item)}>
                                        <Member data={item} toggle={toggle} setToggle={setToggle} />
                                    </Element>
                                )}
                            </Element>
                        </Element>
                    : <Element tag={`div`} className={styles.emptyData}><EmptyData content={`회원 목록은`} /></Element>}
                    {pageRef.current !== null && memberList.length > 0 ? <Element tag={`div`} propRef={inViewRef}><Spinner inView={true} /></Element> : null}
                </FlickPanel>
            </Element>
        </Section>
        {/* date-range - bottomsheet */}
        {datepicker ? <DateRangeBottomsheet isOpen={datepicker} onDismiss={onDatePickerDismissHandler} startDate={startDate} setStartDate={setStartDate} endDate={endDate} setEndDate={setEndDate} minDate={null} maxDate={new Date()} /> : null}
    </>
    );
}